import moment from "moment/moment";

const DateUtils = {
    differenceDays: function (now, past) {
        if (now === null || past === null || now === "" || past === "") {
            console.error("Invalid date");
            return 0;
        }
        if (!(now instanceof Date) || !(past instanceof Date)) {
            console.error("Invalid date objects");
            return 0;
        }

        let diff = now - past;
        return Math.floor(diff / (1000 * 60 * 60 * 24));
    },
    dayMonthPlace: (datedInput) => {
        const dated = moment.isMoment(datedInput)
            ? datedInput
            : moment(datedInput, "YYYY-MM-DD");
        if (!dated.isValid()) {
            console.error("Invalid date input");
            return 0;
        }
        const weekday = parseInt(dated.format("d"));
        let counter = 0;

        // first day month
        let initMonth = moment(dated).startOf("month");

        // Iterar por los días del mes hasta la dated
        while (initMonth.isSameOrBefore(dated, "day")) {
            if (parseInt(initMonth.format("d")) === weekday) {
                counter++;
            }
            initMonth.add(1, "day");
        }
        return counter;
    },
    lastDayMonth: (fecha, weekday) => {
        const dated = moment.isMoment(fecha) ? fecha : moment(fecha, "YYYY-MM-DD");
        if (!dated.isValid()) {
            console.error("Fecha inválida");
            return null;
        }
        let lastDay = dated.clone().endOf("month");
        while (lastDay.weekday() !== weekday) {
            lastDay.subtract(1, "day");
        }
        // Day number of month
        return lastDay.date();
    },
    dateToStringInput: (date) => {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    dateToStringSpanish: (date) => {
        let year = date.getFullYear();
        let month = ("0" + (date.getMonth() + 1)).slice(-2);
        let day = ("0" + date.getDate()).slice(-2);
        return day + "-" + month + "-" + year;
    }
}
export default DateUtils;